module.exports = __webpack_public_path__ + "img/Tribo4.0aba24c6.webp";